import { Sort } from "@models/sort.model";
import { BaseConverter } from "./base.converter";
import { SortDto } from "@dtos/sort.dto";



export class SortConverter extends BaseConverter <Sort,SortDto>{

    modelToDto(model: Sort): SortDto {
        return new SortDto(
            model.sorted,
            model.empty,
            model.unsorted
        )
    }
    dtoToModel(dto: SortDto): Sort {
        return new Sort(
            dto.sorted,
            dto.empty,
            dto.unsorted
        )
    }

}